"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.parseBrandedDef = void 0;
const parseDef_js_1 = require("../parseDef.js");
function parseBrandedDef(_def, refs) {
    return (0, parseDef_js_1.parseDef)(_def.type._def, refs);
}
exports.parseBrandedDef = parseBrandedDef;
